<div class="navbar position-relative" [class.navbar-expanded]="navbarIsExpanded">

    <div class="flex">
        <uvx-icon icon="logo-1" size="xl" class="navbar-logo"></uvx-icon>
    </div>

    <div class="divider"></div>

    <div class="content">

        <ng-content></ng-content>

    </div>

</div>
